const React = require('react');

const CommonTypes = require('../common/Types.jsx');
const Config = require('../utility/Config.jsx');
const ContentContainer = require('../common/ContentContainer.jsx');
const Item = require('./Item.jsx');
const ItemMeta = require('./ItemMeta.jsx');
const ItemV2 = require('../common/ItemV2.jsx');
const _ItemContainer = require('../common/ItemContainer.jsx');
const _ItemContainerV2 = require('../common/ItemContainerV2.jsx');
const Name = require('../utility/Name.jsx');
const Signature = require('../common/Signature.jsx');
const Statement = require('./Statement.jsx');
const Token = require('../utility/Token.jsx');
const TypeConfig = require('../common/TypeConfig.jsx');
const Utilities = require('../utility/Utilities.jsx');

const ItemBlocks = {
    get: (group, data) => [
        ...CommonTypes.BlocksV2.content.get(group),
        {
            id: 'itemSeparator',
            dataType: 'separator', 
            display: 'Item Detail', 
            group
        },
        {
            id: Name.Block.Inventory.Image,
            component: ItemV2.Image.Component,
            config: {
                Block: ItemV2.Image.TypeConfig.panel.block(),
                Style: ItemV2.Image.TypeConfig.panel.style()
            },
            display: 'Item Image',
            group,
            image: ''
        },
        {
            id: Name.Block.Inventory.Meta,
            component: ItemMeta.Component,
            config: {
                Block: ItemMeta.TypeConfig.panel.block(),
                Style: ItemMeta.TypeConfig.panel.style(),
                Description: ItemMeta.TypeConfig.panel.description(),
                Label: ItemMeta.TypeConfig.panel.label(),
                Value: ItemMeta.TypeConfig.panel.value(data)
            },
            display: 'Item Meta',
            group,
            image: ''
        },
        {
            id: 'certificateSeparator',
            dataType: 'separator', 
            display: 'Certificate of Authenticity', 
            group
        },
        {
            id: Name.Block.AuthenticityStatement,
            component: Statement.V2.Component,
            config: {
                Block: Statement.V2.TypeConfig.panel.block(),
                Style: Statement.V2.TypeConfig.panel.style(),
            },
            display: 'Authenticity Statement',
            group,
            image: ''
        },
        {
            id: Name.Block.Signature,
            component: Signature.V2.Component,
            config: {
                Block: Signature.V2.TypeConfig.panel.block(true),
                Style: Signature.V2.TypeConfig.panel.style(),
                Description: Signature.V2.TypeConfig.panel.description(),
                Label: Signature.V2.TypeConfig.panel.label(),
                Value: Signature.V2.TypeConfig.panel.value()
            },
            display: 'Signature Line',
            group,
            image: ''
        }
    ]
}

function ItemContainerV2(props) {
    const visibilityHash = Utilities.Config.getVisibilityHash({ block: props.config });
    return (
        <ItemContainer
            {...props}
            itemContentContainer={ItemContentContainer}
            v2={true}
            visibility={props.config && props.config.config && props.config.config.Visibility}
            visibilityHash={visibilityHash} />
    )
}

const _ItemContentContainer = Config.withBlockRendering(ContentContainer, ItemBlocks.get(), (props, block) => {
    if (!block.type) {
        return;
    }
    switch (block.type.value) {
        case Name.Block.Columns:
            if (block.config && block.config.Block && block.config.Block.renderHeaderOnlyFirst) {
                return { renderHeader: props.index == 0 }
            }
            break;
    }
});
function ItemContentContainer(props) {
    let config = props.contentConfig;
    if (!config && props.config && props.config.config && props.config.config.Block && props.config.config.Block.design && props.config.config.Block.design.Config) {
        config = Utilities.Config.getDeepCopy(props.config.config.Block.design);
    }
    let componentData;
    if (props.componentData) {
        componentData = props.componentData;
        if (componentData && componentData.length) {
            componentData = componentData[0];
        }
    } else if (props.data && props.data.Inventory && props.data.Inventory.length) {
        componentData = { ...props.data.Inventory[0] };
        // if (componentData.Images && componentData.Images.length) {
        //     componentData.image = { ...componentData.Images[0] };
        // }
    }
    if (!componentData) {
        componentData = {};
    }
    return <_ItemContentContainer {...props} {...componentData} contentConfig={config} />
}

const TypeConfigV2 = {
    defaultDesign: (data) => ({
        "Config": {
            "blocks": [
                {
                    "config": {
                        "Block": {
                            "maxHeight": {
                                "unit": "px",
                                "value": "600"
                            },
                            "maxWidth": {
                                "unit": "px",
                                "value": "600"
                            }
                        },
                        "Style": {
                            "paddingBottom": {
                                "unit": "px",
                                "value": "20"
                            },
                            "textAlign": "center"
                        }
                    },
                    "id": `${Name.Block.Inventory.Image}-${new Date().getTime()}`,
                    "type": {
                        "value": Name.Block.Inventory.Image
                    }
                },
                {
                    "config": {
                        "Block": {
                            "count": "1",
                            "displayType": "columns",
                            "rowCount": "1"
                        },
                        "Style": {},
                        "Description": {},
                        "Label": {},
                        "Value": {
                            "design": ItemMeta.TypeConfig.defaultDesign(data)
                        }
                    },
                    "id": `${Name.Block.Inventory.Meta}-${new Date().getTime()}`,
                    "type": {
                        "value": Name.Block.Inventory.Meta
                    }
                }
            ]
        },
        "Type": Name.Content.CertificateItem
    }),
    panel: {
        block: () => _ItemContainerV2.TypeConfig.panel.block('block', Name.Content.CertificateItem),
        style: () => TypeConfig.panel.layoutStyleV2('block', undefined, {}, undefined, {}),
        visibility: () => {
            return {
                expanded: false,
                label: 'Visibility',
                options: [
                    { display: 'Edition Info', name: Token.Inventory.Edition, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Inventory.Edition, config, Name.Block.Inventory.Meta) },
                    { display: 'Created Date', name: Token.Date, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Date, config, Name.Block.Inventory.Meta) },
                    { display: 'Medium', name: Token.Inventory.Medium, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Inventory.Medium, config, Name.Block.Inventory.Meta) },
                    { display: 'Signature Placement', name: Token.Inventory.Signature, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Inventory.Signature, config, Name.Block.Inventory.Meta) },
                    { display: 'Dimensions', name: Token.Inventory.Dimensions, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Inventory.Dimensions, config, Name.Block.Inventory.Meta) },
                    { display: 'Inventory Number', name: Token.Inventory.Number, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Inventory.Number, config, Name.Block.Inventory.Meta) },
                    { display: 'SKU', name: Token.Inventory.SKU, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Inventory.SKU, config, Name.Block.Inventory.Meta) },
                    { display: 'Retail Price', name: Token.Inventory.Price, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Inventory.Price, config, Name.Block.Inventory.Meta) },
                    { display: 'Alternate Prices', name: Token.Inventory.AlternatePrices, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Inventory.AlternatePrices, config, Name.Block.Inventory.Meta) },
                    { display: 'Inventory Notes', name: Token.Notes, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Notes, config, Name.Block.Inventory.Meta) },
                    { display: 'Artist Biography', name: Token.Artist.Biography, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Artist.Biography, config, Name.Block.Inventory.Meta) }
                ],
                visible: () => false
            };
        }
    }
}

// #region LEGACY

class ItemContainer extends React.Component {
    constructor(props) {
        super(props);

        this.handleComponentType = this.handleComponentType.bind(this);
    }

    handleComponentType(type) {
        switch (type) {
            case Name.Block.Inventory.Image:
                return ItemV2.Image.Component;
            case Name.Block.Inventory.Meta:
                return ItemMeta.Component;
            case 'itemArtist':
                return Item.Artist.Component;
            case 'itemArtistBio':
                return Item.ArtistBio.Component;
            case 'itemCustomMeta':
                return Item.CustomMeta.Component;
            case 'itemDimensions':
                return Item.Dimensions.Component;
            case 'itemEdition':
                return Item.Edition.Component;
            case 'itemInsuranceValue':
                return Item.InsuranceValue.Component;
            case 'itemMedium':
                return Item.Medium.Component;
            case 'itemNotes':
                return Item.Notes.Component;
            case 'itemNumber':
                return Item.Number.Component;
            case 'itemPrice':
                return Item.Price.Component;
            case 'itemSignature':
                return Item.Signature.Component;
            case 'itemSKU':
                return Item.SKU.Component;
            case 'itemTitle':
                return Item.Title.Component;
            case 'itemYear':
                return Item.Year.Component;
            case 'signature':
                return Signature.V1.Component;
            case 'statement':
                return Statement.V1.Component;
            default:
                return null;
        }
    }

    render() {
        const data = this.props.data || {};
        let className = 'itemContainer';
        if (this.props.className) {
            className += ` ${this.props.className}`;
        }
        const PageComponent = this.props.v2 ? _ItemContainerV2.Page : _ItemContainer.Page;
        return (
            <PageComponent
                {...this.props}
                className={className}
                items={data.Inventory}
                onComponentType={this.handleComponentType} />
        );
    }
}

// #endregion LEGACY

module.exports = {
    Blocks: ItemBlocks,
    ContentContainer: ItemContentContainer,
    PageV2: ItemContainerV2,
    TypeConfigV2,

    // LEGACY
    Page: ItemContainer,
    TypeConfig: _ItemContainer.TypeConfig
};